import { A } from '@adornis/base/env-info.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { NotLoggedInError } from '@adornis/users/db/errors.js';
import { UserPreferences } from '../db/UserPreferences.js';
import { getCurrentUserID } from './currentUserID.js';

/**
 * Switch the mail channel for one's own questions on or off. Replaces the former
 * validation-reply preference: that mail listed the blocked fields, this one lets the same
 * person settle them without opening anything.
 */
export const setMyQuestionMailPreference = registerMutation({
  type: () => Boolean,
  operationName: 'setMyQuestionMailPreference',
  resolve: (enabled: boolean) => {
    return async () => {
      const userID = getCurrentUserID();
      if (!userID) throw new NotLoggedInError();
      const collection = await getRawCollection<UserPreferences>(UserPreferences._collectionName);
      await collection.updateOne(
        { userID },
        {
          $set: { receiveQuestionMails: enabled },
          $setOnInsert: { _id: A.getGloballyUniqueID(), userID, _class: UserPreferences._class },
        },
        { upsert: true },
      );
      return enabled;
    };
  },
  params: [{ name: 'enabled', type: () => Boolean }],
});
